import { Navigate } from "react-router-dom";
import { AuthLayout } from "../App";

export const AuthRoute = () => {
  const token = localStorage.getItem("accessToken");
  return token ? <Navigate to="/" replace /> : <AuthLayout />;
};
